export enum PriorityTwoActivityName {
  CoachingStructureAndSystems = 'Coaching Structure and Systems'
}
